<div class="ig-modal">
    <mat-icon class="close-icon" (click)="close()" style="float:right">
        close
    </mat-icon>

    <mat-icon class="main-icon error">error_outline</mat-icon>

    <div class="error-detail" *ngIf="!!errorResponse">
        <div>
            {{errorResponse.message}}
        </div>
    </div>

    <ig-button (trigger)="close()">
        {{errorResponse.ok || 'OK'}}
    </ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/error.modal/common.error.handler.modal/common.error.handler.modal.component.html